export default __webpack_public_path__ + "static/media/heart.e6c0940c.svg";